import React from 'react';
import PropTypes from 'prop-types';

import SelectWithLabelV2 from '../../../../components/composite/FormSets/SelectWithLabelV2/SelectWithLabelV2';
import { userFieldSchemas } from '../../../../utils/validation-utils';
import { setFieldAndValidate } from '../../../../utils/field-utils';

const DisciplineSelectorSet = ({ discipline, setDiscipline, availableDisciplines }) => {
  return (
    <SelectWithLabelV2
      id="discipline"
      label="Discipline"
      value={discipline.value}
      options={[
        {
          display: 'Choose:',
          value: '',
          disabled: false,
        },
        ...availableDisciplines.map(
          discipline => ({
            display: discipline.label,
            value: discipline.value,
            disabled: false,
          }),
        ),
      ]}
      onChange={({ target: { value } }) => setFieldAndValidate(discipline, setDiscipline, value, userFieldSchemas.discipline) }
    />
  );
};

DisciplineSelectorSet.propTypes = {
  discipline: PropTypes.object.isRequired,
  setDiscipline: PropTypes.func.isRequired,
  availableDisciplines: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
};

export default DisciplineSelectorSet;